import { Button, Flex, Spinner } from '@arkestro/arkestro-design-system';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  cancelLabel?: string;
  isSaving: boolean;
  isValid: boolean;
  onClose: () => void;
  onSubmit: () => void;
  submitLabel?: string;
  type: string;
}

export const Footer = ({ cancelLabel, onClose, onSubmit, isValid, isSaving, submitLabel, type }: Props) => {

  const { t } = useTranslation('common');

  return (
    <Flex gap={16} justify='end'>
      <Button
        dataTestId='cancel-button'
        disabled={isSaving}
        ghost
        onClick={onClose}
        size='large'
        type='primary'
      >
        {cancelLabel || t('rfx_drawer.cancel_button')}
      </Button>
      <Button
        dataTestId='submit-button'
        disabled={!isValid || isSaving}
        onClick={onSubmit}
        size='large'
        type='primary'
      >
        <Flex align='center' gap={8}>
          {isSaving ? <><Spinner size='small' /> {t('rfx_drawer.saving')} </> : submitLabel || t('rfx_drawer.submit_button', { type })}
        </Flex>
      </Button>
    </Flex>
  );
};
